// src/components/sections/FaqSection.jsx
import React, { useState } from "react";
import { faqMeta, faqList } from "../../data/faqData";

// --- Plus & Minus Icons for Accordion ---
const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const MinusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-8 xs:py-9 sm:py-12 md:py-16 px-4 xs:px-5 sm:px-6 md:px-12 bg-white relative overflow-hidden">

      {/* Background watermark image removed — it was a near-invisible (4% opacity)
          decorative element pointing at a deleted asset. Safe to leave out;
          nothing else depends on it. */}

      {/* Grid Layout Container */}
      <div className="max-w-[1000px] mx-auto flex flex-col md:flex-row gap-3 xs:gap-4 sm:gap-6 md:gap-16 relative z-10">
        
        {/* LEFT COLUMN: Heading */}
        <div className="w-full md:w-[35%]">
          <div className="md:sticky md:top-24">
            <h2
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic" }}
              className="text-[22px] xs:text-[26px] sm:text-[34px] md:text-[42px] font-medium leading-[1.1] mb-2 xs:mb-3 md:mb-6 text-[#1A1A1A]"
            >
              {faqMeta.heading}
            </h2>
          </div>
        </div>

        {/* RIGHT COLUMN: Accordion FAQ List */}
        <div className="w-full md:w-[65%] flex flex-col">
          {faqList.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div 
                key={faq.id} 
                className="border-b border-[#EAE3DA] py-3 xs:py-3.5 sm:py-4 md:py-5"
              >
                {/* Question Header */}
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full flex justify-between items-center text-left focus:outline-none group active:opacity-70 transition-opacity"
                >
                  <h3
                    style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic" }}
                    className="text-[15px] xs:text-[16.5px] sm:text-[20px] md:text-[22px] font-medium pr-3 xs:pr-4 sm:pr-6 leading-snug transition-colors duration-300 text-[#1A1A1A] opacity-90 group-hover:opacity-100"
                  >
                    {faq.question}
                  </h3>
                  <div
                    className={`shrink-0 w-6 h-6 xs:w-7 xs:h-7 rounded-full flex items-center justify-center transition-transform duration-300 bg-[#F7F3EC] ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                  >
                    {isOpen ? <MinusIcon /> : <PlusIcon />}
                  </div>
                </button>

                {/* Answer Body */}
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100 mt-2 sm:mt-3" : "grid-rows-[0fr] opacity-0 mt-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p 
                      style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic" }} 
                      className="text-[13.5px] xs:text-[15px] sm:text-[18px] md:text-[20px] leading-relaxed pr-3 xs:pr-4 sm:pr-8 text-[#1A1A1A] opacity-80"
                    >
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FaqSection;